export const errorLogin = (error) => {
    // Allow callers that accidentally pass error.message (a string) to still resolve
    // to a code by scanning for the "(auth/...)" suffix Firebase adds to messages.
    if (typeof error === 'string') {
        const match = error.match(/\(auth\/[\w-]+\)/);
        error = match ? { code: match[0].slice(1, -1), message: error } : { message: error };
    }

    switch (error?.code) {
        case "auth/user-not-found":
            return "Email not found. Please sign up to create an account.";
        case "auth/wrong-password":
            return "Incorrect password. Please try again.";
        case "auth/invalid-email":
            return "Invalid email format.";
        case "auth/user-disabled":
            return "This account has been disabled.";
        case "auth/missing-password":
            return "Password not set for this account. Please click 'Forgot Password' to generate your password.";
        case "auth/invalid-app-credential":
            return "Enter a valid app credential.";
        case "auth/code-expired":
            return "OTP expired. Please resend OTP.";
        case "auth/account-exists-with-different-credential":
            return "An account already exists with this email using a different sign-in method.";
        case "auth/invalid-phone-number":
            return "Invalid phone number.";
        case "auth/email-already-in-use":
            return "Email is already registered. Please sign in instead.";
        case "auth/weak-password":
            return "Password is too weak. Please use a stronger password.";
        case "auth/too-many-requests":
            return "Too many attempts. Please try again after some time.";
        case "auth/network-request-failed":
            return "Network error. Please check your connection and try again.";
        case "auth/requires-recent-login":
            return "Please sign in again to continue.";
        case "auth/credential-already-in-use":
            return "This credential is already linked to another account.";
        case "auth/provider-already-linked":
            return "This account is already linked with this provider.";
        case "auth/invalid-verification-code":
            return "Invalid OTP. Please check and try again.";
        case "auth/invalid-verification-id":
            return "Verification session expired. Please request a new OTP.";
        case "auth/missing-verification-code":
            return "Please enter the verification code.";
        case "auth/missing-verification-id":
            return "Verification session missing. Please request a new OTP.";
        case "auth/popup-closed-by-user":
            return "Sign-in popup was closed before completing.";
        case "auth/popup-blocked":
            return "Popup was blocked by your browser. Please allow popups and try again.";
        case "auth/cancelled-popup-request":
            return "Sign-in cancelled.";
        case "auth/operation-not-allowed":
            return "This sign-in method is not enabled. Please contact support.";
        case "auth/quota-exceeded":
            return "Quota exceeded. Please try again later.";
        case "auth/invalid-credential":
        case "auth/invalid-login-credentials":
            return "Invalid email or password. Please try again.";
        case "auth/expired-action-code":
            return "This link has expired. Please request a new one.";
        case "auth/invalid-action-code":
            return "Invalid or already used link. Please request a new one.";
        case "auth/user-token-expired":
            return "Your session has expired. Please sign in again.";
        case "auth/web-storage-unsupported":
            return "Your browser does not support web storage. Please enable it or try another browser.";
        case "auth/unauthorized-domain":
            return "This domain is not authorized for sign-in.";
        default: {
            const raw = error?.message || "An error occurred. Please try again.";
            const cleaned = raw
                .replace(/^Firebase:\s*/i, '')
                .replace(/\s*\(auth\/[\w-]+\)\.?$/i, '')
                .trim();
            return cleaned || "An error occurred. Please try again.";
        }
    }
};
